import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { ColorStatusRendererComponent } from './color-status-renderer.component';

@NgModule({
  declarations: [ ColorStatusRendererComponent ],
  exports: [ ColorStatusRendererComponent ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  providers: [
    TranslatePipe
  ]
})
export class ColorStatusRendererModule { }
